import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NewsRssService } from './news-rss.service';
import { INewsRss } from '@src/app/interfaces/news-rss.inteface';
import { LanguageService } from '@shared/services/language.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsComponent implements OnInit {

  @Output() public close$: EventEmitter<void> = new EventEmitter();

  @Input('isVisible') public set visible(value: boolean) {
    this._isVisible = value;
  };

  public _isVisible: boolean;
  public posts: INewsRss[] = [];
  public currentPage: number = 1;
  public totalPages: number = 0;

  public readonly langauge: string = this.languageService.current;

  constructor(
    private newsRssService: NewsRssService,
    private changeDetRef: ChangeDetectorRef,
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    this.newsRssService.fetchPosts().subscribe(() => {
      this.totalPages = this.newsRssService.getTotalPages();
      this.loadPage(this.currentPage);
    });
  }

  public onClickClose(): void {
    this.close$.emit();
  }

  public trackByPosts(index: number, item: INewsRss): number {
    return item.id;
  }

  public loadPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;

    this.currentPage = page;
    this.newsRssService.getPostsByPage(this.currentPage).subscribe((data) => {
      this.posts = data;
      this.changeDetRef.markForCheck();
    });
  }

}
